export default "__VITE_ASSET__0Og$sw56__"